import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=1208902c&scoped=true"
import script from "./ForgotPasswordForm.ts?vue&type=script&lang=ts&external"
export * from "./ForgotPasswordForm.ts?vue&type=script&lang=ts&external"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&id=1208902c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1208902c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1208902c')) {
      api.createRecord('1208902c', component.options)
    } else {
      api.reload('1208902c', component.options)
    }
    module.hot.accept("./ForgotPasswordForm.vue?vue&type=template&id=1208902c&scoped=true", function () {
      api.rerender('1208902c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Auth/components/ForgotPasswordForm/ForgotPasswordForm.vue"
export default component.exports